import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Redirect, Route } from 'react-router-dom';

import Header from '../components/header/Header';
import Sidebar from '../components/sidebar/Sidebar';
import ROUTES from '../data/routes';

export const PrivateRoute = ({
  isStarted,
  isAuthenticated,
  component: Component,
  menuRotes,
  code,
  actions,
  ...rest
}) => {
  if (isStarted) {
    return (
      <Route
        {...rest}
        component={props => (
          isAuthenticated ? (
            <div id="page-container" className="page-sidebar-fixed page-header-fixed">
              <Header />
              <Sidebar />
              <div id="content" className="content">
                {menuRotes && (!code || menuRotes[code]) ?
                <Component actions={actions} {...props} /> : (menuRotes ? <h3 style={{color:'red'}}>{ I18n.t('noAccessPermissionCode')}{code}</h3> : <h3></h3>)
                }
              </div>
            </div>
          ) : (
            <Redirect to={ROUTES.LOGIN} />
          )
        )}
      />
    );
  }
  return (null);
};

const mapStateToProps = state => ({
  isStarted: state.activities.started,
  isAuthenticated: state.auth.authenticated,
  menuRotes: state.admMenus && state.admMenus.admMenuRoutes,
});

export default connect(mapStateToProps)(PrivateRoute);
